// getWinrateColor.js
export default (winRate, avgWinRate, inverse = false) => {
  const winrateComparison = inverse
    ? avgWinRate / winRate
    : winRate / avgWinRate;
  let winrateColor;
  switch (true) {
    case winrateComparison >= 1.5:
      winrateColor = "#30D9D4";
      break;
    case winrateComparison >= 1.4:
      winrateColor = "#79D6D6";
      break;
    case winrateComparison >= 1.3:
      winrateColor = "#9DD5D7";
      break;
    case winrateComparison >= 1.2:
      winrateColor = "#C1D4D8";
      break;
    case winrateComparison >= 1.1:
      winrateColor = "#C1D4D8";
      break;
    case winrateComparison <= 0.9:
      winrateColor = "#D5B1B5";
      break;
    case winrateComparison <= 0.75:
      winrateColor = "#D5B1B5";
      break;
    case winrateComparison <= 0.6:
      winrateColor = "#DD7A7D";
      break;
    case winrateComparison <= 0.45:
      winrateColor = "#DD7A7D";
      break;
    case winrateComparison <= 0.3:
      winrateColor = "#E44C4D";
      break;
    default:
      winrateColor = "#C1D4D8";
  }
  return winrateColor;
};

export const getColorWithRange = ({
  value,
  low,
  high,
  lowerBetter = false,
  positiveOnly = false,
}) => {
  const topPercent = (value + low) / (high - low);
  let winrateComparison = lowerBetter ? 1 - topPercent : topPercent;
  if (positiveOnly) winrateComparison = winrateComparison * 0.5 + 0.5;

  let winrateColor;
  switch (true) {
    case winrateComparison >= 0.9:
      winrateColor = "#30D9D4";
      break;
    case winrateComparison >= 0.8:
      winrateColor = "#79D6D6";
      break;
    case winrateComparison >= 0.7:
      winrateColor = "#9DD5D7";
      break;
    case winrateComparison >= 0.6:
      winrateColor = "#C1D4D8";
      break;
    case winrateComparison >= 0.5:
      winrateColor = "#C1D4D8";
      break;
    case winrateComparison <= 0.49:
      winrateColor = "#D5B1B5";
      break;
    case winrateComparison <= 0.4:
      winrateColor = "#D5B1B5";
      break;
    case winrateComparison <= 0.3:
      winrateColor = "#DD7A7D";
      break;
    case winrateComparison <= 0.2:
      winrateColor = "#DD7A7D";
      break;
    case winrateComparison <= 0.1:
      winrateColor = "#E44C4D";
      break;
    default:
      winrateColor = "#C1D4D8";
  }
  return winrateColor;
};
